module.exports = __webpack_public_path__ + "img/log.aeab6c9e.png";